const common = ({ theme }) => ({
  // section: {},
  '& .formItem': {
    marginBottom: 25
  },
  '& .select': {
    '& .StyledInput-inputBase': {
      borderRadius: 5
    },
    '& .MuiSelect-select': {
      padding: '6px 0 6px',
      paddingLeft: 6,
      paddingRight: 24
    }
  },
  '& .label': {
    marginBottom: 13,
    fontSize: 11,
    fontWeight: 'bold',
    lineHeight: '12px',
    color: '#A4A3A4',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 17
    }
  },
  '& .value': {
    fontSize: 16,
    fontWeight: 'bold',
    lineHeight: '18px',
    color: '#3D3D3D'
  },
  '& .mainAction': {
    padding: '15px 19px',
    fontSize: 14,
    lineHeight: '16px',
    borderRadius: 7,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      fontSize: 13,
      lineHeight: '14px',
      borderRadius: 7
    }
  },
  '& .ellipsisText': {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  '& .dialogHeader': {
    padding: '13px 13px 12px',
    display: 'flex',
    alignItems: 'center',
    flex: '0 0 auto',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      padding: '5px 17px'
    }
  },
  '& .dialogTitle': {
    flex: 1,
    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: 18,
    lineHeight: '24px',
    letterSpacing: 0,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      fontSize: 16,
      lineHeight: '18px',
      color: '#000'
    }
  },
  '& .headerAction_start': {
    flex: '0 0 44px'
  },
  '& .headerAction_end': {
    flex: '0 0 44px'
  },
  '& .dialogContent': {
    padding: '0 17px 33px',
    flex: '1 1 auto',
    overflowY: 'auto'
  },
  '& .chips': {
    marginTop: -13,
    display: 'flex',
    flexWrap: 'wrap'
  },
  '& .chips__item': {
    marginTop: 13,
    padding: '9px 8px',
    textAlign: 'center',
    fontSize: 12,
    fontWeight: 'bold',
    color: '#FFF',
    background: '#8782BC',
    borderRadius: 6
  },
  '& .chipsBtn': {
    marginTop: 22,
    fontSize: 12
  },
  '& .multiFormContainer': {
    // maxWidth: 440,
    width: '100%',
    marginBottom: 33,
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gridGap: 23,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      display: 'flex',
      overflowX: 'auto'
    }
  },
  '& .multiFormItemOuter': {
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      minWidth: 230
    }
  },
  '& .multiFormItemOuter_withBorderedInner': {
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      minWidth: 218
    }
  },
  '& .multiFormItemInner': {
    borderRadius: 6
  },
  '& .multiFormItemInner_bordered': {
    padding: '11px 8px 19px',
    border: '1px solid #E6E6E6'
  },
  '& .multiFormItemInner_bordered_main': {
    borderColor: theme.palette.primary.main
  },
  '& .multiFormItem__inputItem': {
    position: 'relative',
    marginBottom: 15
  },
  '& .multiFormItem__label': {
    marginBottom: 12,
    fontSize: 8
  },
  '& .multiFormItem__checkBox': {
    position: 'absolute',
    right: 0,
    top: -3,
    zIndex: 1,
    '& .StyledCheckbox-checkbox': {
      width: 12,
      minWidth: 12,
      height: 12,
      borderRadius: 3,
      fontSize: 12
    },
    '& .StyledCheckbox-label': {
      marginLeft: 0,
      marginRight: 25,
      marginBottom: 0,
      fontSize: 8,
      lineHeight: '12px'
    }
  },
  '& .multiFormItem__input': {
    '& .StyledInput-inputBase': {
      fontSize: 12,
      lineHeight: '14px'
    },
    '& .StyledInput-inputBase__input': {
      padding: '4px 0'
    }
  },
  '& .multiFormItem__helperText': {
    fontSize: 10,
    lineHeight: '14px'
  },
  '& .multiFormItem__headerAction': {
    fontSize: 11,
    lineHeight: '12px',
    color: '#C43D47',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginLeft: 15,
      fontSize: 14,
      lineHeight: '16px'
    }
  }
});

const container = ({ theme }) => ({
  '&.container': {
    position: 'relative',
    display: 'flex',
    flex: 1,
    overflow: 'hidden',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      overflow: 'auto',
      padding: '0 16px'
    }
  },
  '& .loaderOverlay': {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.7)'
  },
  '& .column': {
    width: '100%',
    overflow: 'auto',
    '&:first-of-type': {
      maxWidth: 155,
      marginRight: 32,
      paddingLeft: 30
    },
    '&:last-of-type': {
      paddingRight: 30
    }
  },
  '& .contentItem': {
    padding: '10px 0',
    '& > a': {
      color: 'inherit'
    },
    '&:not(:last-of-type)': {
      borderBottom: '1px solid #ECECF5'
    }
  },
  '& .desktopLayout': {
    width: '100%',
    display: 'flex'
  },
  '& .mobileLayout': {
    width: '100%'
  }
});

const profile = ({ theme }) => ({
  '&.profile__container': {
    width: '100%',
    padding: '16px 0 58px',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      flexDirection: 'column'
    }
  },
  '& .profile__headerAction': {
    marginLeft: 12,
    fontSize: 13,
    lineHeight: '14px',
    '&.profile_saveBtn': {
      padding: '4px 14px',
      borderRadius: 12
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginLeft: 15,
      fontSize: 14,
      lineHeight: '16px'
    }
  },
  '& .profile__formGroup': {
    minWidth: 226,
    '&:not(:first-of-type)': {
      width: '100%',
      marginLeft: 60,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginLeft: 0
      }
    }
  },
  '& .profile__imageTypeTip': {
    marginTop: 4,
    marginBottom: 20,
    fontSize: 9,
    fontWeight: 'bold',
    lineHeight: '10px',
    color: '#A4A3A4',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginTop: 14,
      marginBottom: 24,
      fontSize: 10,
      lineHeight: '11px'
    }
  },
  '& .profile__imagePreview': {
    height: 230,
    width: 230,
    objectFit: 'cover',
    borderRadius: 14,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      width: 227,
      height: 227
    }
  },
  '& .profile__formColumnsWrapper': {
    display: 'flex',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      flexDirection: 'column'
    }
  },
  '& .profile__formColumns': {
    display: 'grid',
    gridTemplateColumns: 'min(226px) 1fr',
    columnGap: 60,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      gridTemplateColumns: '1fr'
    }
  },
  '& .profile__addressGroup': {
    display: 'grid',
    gridTemplateColumns: 'min(226px) 1fr',
    columnGap: 60,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      gridTemplateColumns: '1fr 1fr',
      columnGap: 20
    }
  },
  '& .profile__mediaGroup': {
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      order: -1
    }
    // '& > div:first-of-type': {
    //   display: 'flex',
    //   [theme.breakpoints.down(theme.desktopBreakPoint)]: {
    //     flexDirection: 'column'
    //   }
    // }
  },
  '& .profile__videoPreview': {
    minHeight: 230,
    maxWidth: 406,
    marginBottom: 40,
    borderRadius: 14
  },
  '& .profile__experienceDescription': {
    maxWidth: 556,
    marginBottom: 16,
    fontSize: 10,
    fontWeight: 'bold',
    lineHeight: '12px',
    color: '#000'
  },
  '& .linkCompanyBtn': {
    width: 110,
    height: 25,
    padding: 0,
    fontSize: 8,
    lineHeight: '9px',
    borderRadius: 3
  },
  '& .rateCompanyBtn': {
    width: 85,
    height: 25,
    fontSize: 8,
    lineHeight: '9px',
    borderRadius: 3
  },
  '& .rateCompanyBtn__icon': {
    fontSize: 16
  },
  '& .linkCompanyText': {
    fontSize: 8,
    lineHeight: '9px',
    color: theme.palette.primary.main
  },
  '& .cvIconContainer': {
    position: 'relative',
    minWidth: 70,
    height: 90,
    marginRight: 22,
    border: `2px solid ${theme.palette.primary.main}`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 5,
    fontSize: 30
  },
  '& .cvCheckIcon': {
    position: 'absolute',
    top: 4,
    right: 4,
    fontSize: 12,
    color: '#2BB673'
  },
  '& .certificates__checkIcon': {
    fontSize: 20,
    color: '#E5E5E5'
  },
  '& .certificates_checked': {
    color: '#1C75BC'
  }
});

const notice = ({ theme }) => ({
  '&.notice__container': {
    width: '100%',
    padding: '29px 0 70px',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      paddingTop: 13
    }
  },
  '& .notice__sectionHeader': {
    display: 'flex',
    alignItems: 'center'
  },
  '& .notice__sectionHeader__item': {
    width: 60,
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 'bold',
    lineHeight: '12px',
    color: '#A4A3A4',
    '&:not(:first-of-type)': {
      marginLeft: 51,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginLeft: 12
      }
    }
  },
  '& .notice__header': {
    display: 'none',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 17,
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center'
    }
  },
  '& .notice__header__item': {
    width: 60,
    textAlign: 'center',
    fontSize: 11,
    fontWeight: 'bold',
    lineHeight: '12px',
    color: '#A4A3A4',
    '&:not(:first-of-type)': {
      marginLeft: 51,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginLeft: 12
      }
    }
  },
  '& .notice__group': {
    '&:not(:last-of-type)': {
      marginBottom: 10,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginBottom: 20
      }
    }
  },
  '& .notice__groupHeader': {
    display: 'flex',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 8
    }
  },
  '& .notice__labelContainer': {
    width: '100%'
  },
  '& .notice__actionsContainer': {
    position: 'relative',
    top: 12,
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      position: 'static'
    }
  },
  '& .notice__group__name': {
    width: '100%',
    marginBottom: 7
  },
  '& .notice__descr': {
    maxWidth: '60%',
    position: 'relative',
    top: -7,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      maxWidth: '100%',
      position: 'static'
    }
  },
  '& .notice__descr__text': {
    marginBottom: 0,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      fontSize: 12,
      lineHeight: '13px'
    }
  },
  '& .notice__switchRoot': {
    '&:not(:first-of-type)': {
      marginLeft: 51,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginLeft: 12
      }
    }
  },
  '& .course': {
    position: 'relative',
    minHeight: 140,
    padding: '11px 8px 19px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    borderRadius: 6,
    backgroundColor: theme.palette.moreColors.grey_2
  },
  '& .course__assignedLabel': {
    position: 'absolute',
    right: 8,
    fontSize: 8,
    fontWeight: 'bold',
    lineHeight: '12px',
    color: theme.palette.primary.main
  },
  '& .course__label': {
    fontSize: 8
  },
  '& .course__value': {
    padding: '4px 0',
    borderBottom: '1px solid rgba(0,0,0,0.1)',
    fontSize: 12,
    lineHeight: '14px',
    color: '#2C2C2C'
  },
  '& .course__action': {
    padding: '3px 12px',
    fontSize: 12,
    borderRadius: 16
  }
});

const account = ({ theme }) => ({
  '&.account__container': {
    width: '100%',
    padding: '29px 0 50px'
  },
  '& .account__pwdForm': {
    marginBottom: 45,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 41
    }
  },
  '& .account__title': {
    marginBottom: 18,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 23
    }
  },
  '& .account__formItem': {
    width: '100%',
    marginBottom: 27,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 24
    }
  },
  '& .account__doubleCol': {
    width: '100%',
    display: 'flex',
    '& .account__formItem:last-of-type': {
      marginBottom: 19,
      marginLeft: 20,
      [theme.breakpoints.down(theme.desktopBreakPoint)]: {
        marginBottom: 19,
        marginLeft: 0
      }
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      flexDirection: 'column'
    }
  }
});

export default ({ theme }) => ({
  ...common({ theme }),
  ...container({ theme }),
  ...profile({ theme }),
  ...notice({ theme }),
  ...account({ theme })
});
